import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ProducerSettings } from "@/hooks/useProducerSettings";

interface Props {
  settings: ProducerSettings;
  onUpdate: (updates: Partial<ProducerSettings>) => void;
}

export function ProducerPDFSettings({ settings, onUpdate }: Props) {
  return (
    <Card className="space-y-6 p-6">
      <div>
        <h2 className="mb-2 text-xl font-semibold">PDF export settings</h2>
        <p className="text-sm text-muted-foreground">
          Configure default options for PDF exports (briefing, analytics, schedule).
        </p>
      </div>

      <div className="space-y-2">
        <Label>Time format</Label>
        <Select
          value={settings.pdf_time_format}
          onValueChange={(value: "24h" | "12h") => onUpdate({ pdf_time_format: value })}
        >
          <SelectTrigger className="w-[200px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="24h">24-hour (22:00)</SelectItem>
            <SelectItem value="12h">12-hour (10PM)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Default export view</Label>
        <Select
          value={settings.pdf_default_view}
          onValueChange={(value: "list" | "timeline") => onUpdate({ pdf_default_view: value })}
        >
          <SelectTrigger className="w-[200px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="list">List view (tabular)</SelectItem>
            <SelectItem value="timeline">Timeline view (visual)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Filename structure</Label>
        <Select
          value={settings.pdf_filename_structure}
          onValueChange={(value: "festival_date" | "crew_name" | "festival_day_view") =>
            onUpdate({ pdf_filename_structure: value })
          }
        >
          <SelectTrigger className="w-[280px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="festival_date">{"{festival}_{date}_schedule.pdf"}</SelectItem>
            <SelectItem value="crew_name">{"{crewName}_assignments.pdf"}</SelectItem>
            <SelectItem value="festival_day_view">{"{festival}_{day}_{view}.pdf"}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </Card>
  );
}
